import React from 'react';
import Mainwrapper from './components/main-wrapper';
import './App.css';
import './Responsive.css';

function App() {
  return (
    <>
      <Mainwrapper/>
    </>
  );
}

export default App;
